<template>
  <div class="pc-box">
    <div class="pc-search">
      <div class="pc-search-auto">
        <h2><a href="javascript:history.back(-1);">师生互选</a>&gt;&nbsp;<a href="javascript:history.back(-1);">学生列表</a>&gt;&nbsp;学生详情</h2>
      </div>
    </div>
    <div class="aa">
          <div class="infobox">
            <div class="info-top">
              <van-image
                      fit="contain"
                      :src="fileDisplayPrefix + record.header"
              />
              <div class="info-r">
                <div class="lang">
                  <span>{{ record.name }}<em v-show="record.politicalOutlook">{{ record.politicalOutlook }}</em></span>
                  <span v-show="record.studentCode">学号：{{ record.studentCode }}</span>
                </div>
                <div class="lang">
                  <span>性别：{{getDictName(genderList, record.gender) || record.gender}}</span>
                  <span>生日：{{ record.birthday }}</span>
                </div>
                <div class="lang">
                  <span style="width: 100%" v-show="record.faculty">院系：{{ record.faculty }}</span>
                  <!--<span style="width: 100%" v-show="record.faculty">院系：{{getDictName(facultyTypeOptions, record.faculty)}}</span>-->
                </div>
              </div>
            </div>
            <!-- 详细信息 -->
            <div class="info-detail">
              <h2>详细信息</h2>
              <dl class="clomum" v-show="record.speciality">
                <dt>专业方向：</dt>
                <dd>{{ record.speciality }}</dd>
              </dl>
              <dl class="clomum" v-show="record.enrollmentYear">
                <dt>入学年份：</dt>
                <dd>{{ record.enrollmentYear }}</dd>
              </dl>
              <dl class="clomum" v-show="record.mobileNum">
                <dt>手机号：</dt>
                <dd>{{ record.mobileNum }}</dd>
              </dl>
              <dl class="clomum" v-show="record.email">
                <dt>电子邮箱：</dt>
                <dd>{{ record.email }}</dd>
              </dl>
              <dl class="clomum" v-show="record.nation">
                <dt>民族：</dt>
                <dd>{{ record.nation }}</dd>
              </dl>
              <dl class="clomum" v-show="record.nativePlace">
                <dt>籍贯：</dt>
                <dd>{{ record.nativePlace }}</dd>
              </dl>
              <dl class="clomum" v-show="record.studentType">
                <dt>学生类型：</dt>
                <dd>{{ record.studentType }}</dd>
              </dl>
              <dl class="clomum" v-show="record.learningExperience">
                <dt>学习经历：</dt>
                <dd>{{ record.learningExperience }}</dd>
              </dl>
              <dl class="clomum" v-show="record.internshipExperience">
                <dt>实习经历：</dt>
                <dd>{{ record.internshipExperience }}</dd>
              </dl>
              <dl class="clomum" v-show="record.projectExperience">
                <dt>项目经历：</dt>
                <dd>{{ record.projectExperience }}</dd>
              </dl>
              <dl class="clomum" v-show="record.honorAward">
                <dt>荣誉奖励：</dt>
                <dd>{{ record.honorAward }}</dd>
              </dl>
              <dl class="clomum" v-show="record.remark">
                <dt>备注：</dt>
                <dd>{{ record.remark }}</dd>
              </dl>
              <dl class="clomum" v-show="record.resumePath">
                <dt>简历附件：</dt>
                <dd>
                  <a class="upload-a" :href="fileDisplayPrefix + record.resumePath" target="_blank">查看</a>
                  <a class="upload-a" :href="fileDisplayPrefix + record.resumePath" download="简历">下载</a>
                </dd>
              </dl>
              <dl class="clomum" v-show="record.content">
                <dt>个人简介：</dt>
                <dd>
                  <div v-html="record.content"></div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="b-but fiex-box" v-if="((!record.chooseStatus && record.id) || ['2', '3', '4', '5'].includes(record.chooseStatus)) && record.selectCount < 1 && !notSelect">
            <van-button size="small" round type="info" @click="$refs.remark.show(record.chooseRemark)">
              选择学生
            </van-button>
          </div>
      </div>
    <div class="newheight" v-if="((!record.chooseStatus && record.id) || ['2', '3', '4', '5'].includes(record.chooseStatus)) && record.selectCount < 1 && !notSelect"></div>
    <remark ref="remark" title="备注" @handleOk="chooseStudent" />
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType} from '@/api/common'
  import {getStudentDetail, chooseStudent, checkTeacherLimit} from '@/api/teacher/teacherInfo'
  import {getDictName} from '@/utils/common'
  import remark from "./components/remark";
  export default {
    name: 'StudentDetail',
    components: {
      remark
    },
    data() {
      return {
        val: 5,
        genderList: [{value: '0', label: '女'}, {value: '1', label: '男'}, {value: '2', label: '未知'},],
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        id: '',
        activityId: '',
        record: {},
        facultyTypeOptions: [],
        commentData: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
        queryParams: {},
        getDictName,
        loading: false,
        notSelect: true
      }
    },
    computed: {},
    created() {
      this.id = this.$route.query.id;
      this.activityId = this.$route.query.activityId
      this.getDict();
      this.refresh()

      // 检查老师可选择数量
      checkTeacherLimit(this.activityId).then(res => {
        if (res.code === 10000) {
          this.notSelect = res.result || false
          if (this.notSelect) {
            this.$toast('名额已满')
          }
        }
      })
    },
    mounted() {
    },
    methods: {
      refresh() {
        this.getDetailInfo()
      },
      // 加载数据
      onLoad() {
        if (this.commentData.current > 1 && this.commentData.hasMore) {
          this.getCommentInfoList()
        }
      },
      chooseStudent(remark) {
        this.record.chooseRemark = remark
        chooseStudent(this.record.studentCode, this.activityId, remark).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      },
      getDetailInfo() {
        // 学生详情
        getStudentDetail(this.id, this.activityId).then(res => {
          if (res.code === 10000) {
            this.record = res.result
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 100)
        });
      },
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      }
    }
  }
</script>

<style scoped>
.pc-search h2{
  display:none;
}
  /deep/ .van-list {
    padding: 0;
  }

  /deep/ .van-tabs__content {
    margin-top: 10px;
  }

  .aa {
    background: #ffffff;
  }

  .info-top {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid #dedede;
  }

  /deep/ .info-top .van-image {
    width: 82px;
    height: 94px;
    background: #ECECEC;
    padding: 3px;
    display: flex;
    margin-right: 7px;
  }

  .info-r {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .info-r .lang {
    display: flex;
    align-items: center;
  }

  .info-r .lang span {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin: 5px 0;
  }

  .lang-span {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin: 5px 0;
  }

  .info-r .lang span em {
    height: 16px;
    background: #FF0000;
    border-radius: 3px;
    padding: 0 2px;
    font-size: 11px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 2px;
  }

  .info-detail {
    padding: 0 10px;
  }

  .info-detail h2 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    padding: 15px 0;
  }

  .info-detail dl {
    display: flex;
    padding: 10px 0;
    justify-content: space-between;
    border-bottom: 1px solid #EAEAEA;
  }

  .info-detail dl dt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /*display: flex;*/
    /*align-items: center;*/
    max-width: 150px;
  }

  .info-detail dl dd {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    flex: 1;
    text-align: right;
  }

  .info-detail dl.clomum {
    flex-direction: column;
  }

  .info-detail dl.clomum dt {
    flex-direction: column;
    max-width: 100%;
    align-items: flex-start;
    font-weight: 600;
  }

  .info-detail dl.clomum dd {
    white-space: pre-wrap;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1000000000;
    -webkit-box-orient: vertical;
    text-align: left;
    padding-top: 10px;
    line-height: 21px;
  }

  .pl-box {
    padding: 0 10px;
  }

  .pj-list {
    background: #FFFFFF;
    border-radius: 6px;
    margin: 10px 0;
    padding: 15px;
    display: flex;
    flex-direction: column;
  }

  .pl-top {
    display: flex;
    align-items: center;
  }

  /deep/ .pl-top .van-image {
    display: flex;
    width: 36px;
    height: 36px;
    border-radius: 100px;
    margin-right: 5px;
  }

  /deep/ .pl-top .van-image__error {
    display: flex;
    width: 36px;
    height: 36px;
    border-radius: 100px;
    margin-right: 5px;
  }

  .pl-top span {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .pl-top span h2 {
    display: flex;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-bottom: 7px;
  }

  .pl-top span em {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
  }

  .pl-bottom {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  .pl-bottom .pls {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
  }

  .pl-bottom span {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    display: flex;
    width: 60px;
    padding-top: 4px;
  }

  /deep/ .van-rate {
    display: flex;
    flex: 1;
  }

  /deep/ .van-rate__icon {
    font-size: 15px;
  }

  /deep/ .van-rate__icon--full {
    color: #6988FF;
  }

  .pl-bottom .pls p {
    display: flex;
    flex: 1;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 21px;
  }
@media screen and (min-width:1024px){
  .pc-search{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    height: 52px;
  }
  .pc-search h2{
    display: flex;
    padding: 0;
    font-size:18px;
    font-weight: 600;
    color: #999999;
  }
  .pc-search-auto{
    width: 1024px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pc-search-auto h2 a{
    padding: 0 10px 0 10px;
    font-size:18px;
    font-weight: 600;
  }
  .pc-box{
    margin: 0 auto;
  }
  .aa{
    width: 1024px;
    background: none;
    margin: 0 auto;
  }
  .info-top{
    background: #ffffff;
    margin:10px 0;
    border-bottom: none;
    border-radius: 6px;
    padding: 20px;
  }
  .info-detail{
    background: #ffffff;
    border-radius: 6px;
    padding: 20px;
  }
  .newheight{
    display: none;
  }
}

  .upload-a {
    color: #2C68E4;
    margin-right: 15px
  }
</style>
